var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ warning: _vm.limitReached }},[_vm._v("Characters: "+_vm._s(_vm.count)+" / "+_vm._s(_vm.limit))])}
var staticRenderFns = []

export { render, staticRenderFns }